import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./Music.css";
import { Card } from "../../interfaces/interfaces"; 
import { Albums, collaborations, grandsEnsembles } from "../../constants"; // Adjust the import path as needed

const Music: React.FC = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [selectedCard, setSelectedCard] = useState<Card | null>(null);

  // Sort Music by date (newest first)
  const sortedAlbums = [...Albums].sort(
    (a, b) => new Date(b.year).getTime() - new Date(a.year).getTime()
  );
  const sortedCollaborations = [...collaborations].sort(
    (a, b) => new Date(b.year).getTime() - new Date(a.year).getTime()
  );
  const sortedGrandsEnsembles = [...grandsEnsembles].sort(
    (a, b) => new Date(b.year).getTime() - new Date(a.year).getTime()
  );
  useEffect(() => {
    const header = document.querySelector(".header-container") as HTMLElement;
    if (header) {
      header.style.backdropFilter = `blur(20px)`;
    }
  }, []);

  const handleCardClick = (card: Card) => {
    setSelectedCard(card);
  };

  const closeModal = () => {
    setSelectedCard(null);
  };

  return (
    <div className="music-container"> 
      <Helmet>
        <title>Music | Zied Zouari</title>
      </Helmet>
      <main className="music-content">
        {/* Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "Albums" ? "active-tab" : ""}
            onClick={() => setActiveTab("Albums")}
          >
            Albums
          </button>
          <button
            className={activeTab === "collaborations" ? "active-tab" : ""}
            onClick={() => setActiveTab("collaborations")}
          >
            Collaborations
          </button>
          <button
            className={activeTab === "grandsEnsembles" ? "active-tab" : ""}
            onClick={() => setActiveTab("grandsEnsembles")}
          >
            Grands Ensembles
          </button>
        </div>

        {/* Content */}
        <div className="cards-container">
          {(activeTab === "Albums"
            ? sortedAlbums
            : activeTab === "collaborations"
            ? sortedCollaborations
            : sortedGrandsEnsembles
          ).map((item) => (
            <div
              key={item.id}
              className="horizontal-card"
              onClick={() => handleCardClick(item)}
            >
              <img src={item.cover} alt={item.title} />
              <div className="card-content">
                <h3>{item.title}</h3>
                <p>{item.artist}</p>
                <p>{item.year}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Full-Screen Modal */}
        {selectedCard && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-modal" onClick={closeModal}>
                ×
              </button>
              <img src={selectedCard.cover} alt={selectedCard.title} />
              <h2>{selectedCard.title}</h2>
              <p>{selectedCard.artist}</p>
              <p>{selectedCard.year}</p>
              <p>{selectedCard.description}</p>
              {selectedCard.link && (
                <button
                  className="category-tag"
                  onClick={() => window.open(selectedCard.link, "_blank")}
                >
                  Plus
                </button>
              )}
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Music;
